export default __webpack_public_path__ + "static/media/monkey2.ade34050.JPG";